<template>
  <v-container>
    <template v-if="loading">
      <v-row justify="start" align-content="center" class="mt-10">
        <img src="../../assets/loading.gif">
      </v-row>
    </template>
    <template v-else>
      <v-card-title class="pa-5 pb-3">
        <p class="font-weight-bold">外部リンク</p>
      </v-card-title>
      <v-card-text class="pa-5 pt-0">
        <ValidationObserver ref="observer" v-slot="{ invalid }">
          <v-form ref="form" v-on:submit.prevent="updateSocialAccount">
            <v-row>
              <v-col cols="12" md="5">
                <ValidationProvider name="Github" rules="max:255|url" v-slot="{ errors }">
                  <span class="font-weight-bold">Github</span>
                  <v-text-field
                    v-model="links.github_url"
                    @change="changeLink"
                    :error-messages="errors"
                    class="pt-0"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="5">
                <ValidationProvider name="Twitter" rules="max:255|url" v-slot="{ errors }">
                  <span class="font-weight-bold">Twitter</span>
                  <v-text-field
                    v-model="links.twitter_url"
                    @change="changeLink"
                    :error-messages="errors"
                    class="pt-0"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="5">
                <ValidationProvider name="その他リンク" rules="max:255|url" v-slot="{ errors }">
                  <span class="font-weight-bold">その他リンク</span>
                  <v-text-field
                    v-model="links.other_url"
                    @change="changeLink"
                    :error-messages="errors"
                    class="pt-0"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="5" class="text-center">
                <v-btn
                  dark
                  color="#5E00BC"
                  class="button-shadow ma-4 font-weight-bold"
                  width="50%"
                  type="submit"
                  :disabled="invalid || isChange"
                >変更する</v-btn>
              </v-col>
            </v-row>
          </v-form>
        </ValidationObserver>
      </v-card-text>
    </template>
  </v-container>
</template>
<script>
export default {
  name: 'UserEditLink',
  data() {
    return {
      links: {
        github_url: '',
        twitter_url: '',
        other_url: '',
      },
      loading: true,
      isChange: true,
    };
  },
  computed: {
    getUserCode() {
      return this.$store.getters['auth/isUserCode']
    },
  },
  methods: {
    getSocialAccount() {
      this.$store.dispatch('userinfo/get', this.getUserCode)
          .then(() => {
            const links = this.$store.getters['userinfo/getUser'];
            this.links.github_url = links.github_url;
            this.links.twitter_url = links.twitter_url;
            this.links.other_url = links.other_url;
            this.loading = false;
          });
    },
    updateSocialAccount() {
      this.$store.dispatch('userinfo/updateSocialAccount', this.links)
      location.reload();
    },
    linkToProfile() {
      this.$router.push({name: 'user', params: {user_code: this.user.user_code}})
    },
    changeLink() {
      this.isChange = false;
    }
  },
  created() {
    return this.getSocialAccount()
  }
}
</script>